import { AlertTriangle, CalendarClock } from "lucide-react";

export const REMIND_DAYS = 7;

export const daysLeft = (date) => {
  if (!date) return null;
  const [y, m, d] = date.split("-").map(Number);
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.round((new Date(y, m - 1, d) - start) / 86400000);
};

const label = (n) => (n < 0 ? `closing date passed ${-n} day${n === -1 ? "" : "s"} ago — still open` : n === 0 ? "closes today" : `closes in ${n} day${n === 1 ? "" : "s"}`);

export const ClosingBadge = ({ job, testId }) => {
  const n = job.status === "open" ? daysLeft(job.valid_through) : null;
  if (n === null || n > REMIND_DAYS) return null;
  return <span data-testid={testId} className={`mt-1 block font-mono text-[11px] uppercase tracking-[0.1em] ${n < 0 ? "text-red-300" : "text-[#E3BC6E]"}`}>{label(n)}</span>;
};

export const ClosingReminders = ({ jobs, onEdit }) => {
  const due = jobs
    .map((j) => ({ j, n: j.status === "open" ? daysLeft(j.valid_through) : null }))
    .filter(({ n }) => n !== null && n <= REMIND_DAYS)
    .sort((a, b) => a.n - b.n);
  if (!due.length) return null;
  return (
    <div data-testid="closing-reminders" className="mb-6 border border-[#E3BC6E]/40 bg-[#E3BC6E]/10 p-5">
      <p className="flex items-center gap-2 font-semibold text-[#E3BC6E]"><CalendarClock className="h-5 w-5" />{due.length} role{due.length === 1 ? "" : "s"} need{due.length === 1 ? "s" : ""} attention from {due.length === 1 ? "its" : "their"} owner</p>
      <ul className="mt-3 space-y-2 text-sm">
        {due.map(({ j, n }, i) => (
          <li key={j.id ?? j._id} data-testid={`closing-reminder-${i}`} className="flex flex-wrap items-center gap-x-3 gap-y-1">
            {n < 0 && <AlertTriangle className="h-4 w-4 text-red-300" />}
            <span className="font-semibold">{j.title}</span>
            <span className={n < 0 ? "text-red-300" : "text-white/85"}>{label(n)} ({j.valid_through})</span>
            <span className="text-slate-300">Owner: {j.owner || "[Hiring owner]"}</span>
            <button onClick={() => onEdit(j)} data-testid={`closing-reminder-edit-${i}`} className="underline underline-offset-2 hover:text-[#E3BC6E]">Extend or close</button>
          </li>
        ))}
      </ul>
    </div>
  );
};
